/* tslint:disable */
/* eslint-disable */
/**
 * Jobs 24/7
 * Jobs 24/7
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: shraaliya0802@gmail.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetAdminDashboard200Response
 */
export interface GetAdminDashboard200Response {
    /**
     * 
     * @type {number}
     * @memberof GetAdminDashboard200Response
     */
    totalJobs?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAdminDashboard200Response
     */
    publishedJobs?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAdminDashboard200Response
     */
    draftJobs?: number;
    /**
     * 
     * @type {number}
     * @memberof GetAdminDashboard200Response
     */
    emails?: number;
}

/**
 * Check if a given object implements the GetAdminDashboard200Response interface.
 */
export function instanceOfGetAdminDashboard200Response(value: object): value is GetAdminDashboard200Response {
    return true;
}

export function GetAdminDashboard200ResponseFromJSON(json: any): GetAdminDashboard200Response {
    return GetAdminDashboard200ResponseFromJSONTyped(json, false);
}

export function GetAdminDashboard200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAdminDashboard200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'totalJobs': json['totalJobs'] == null ? undefined : json['totalJobs'],
        'publishedJobs': json['publishedJobs'] == null ? undefined : json['publishedJobs'],
        'draftJobs': json['draftJobs'] == null ? undefined : json['draftJobs'],
        'emails': json['emails'] == null ? undefined : json['emails'],
    };
}

  export function GetAdminDashboard200ResponseToJSON(json: any): GetAdminDashboard200Response {
      return GetAdminDashboard200ResponseToJSONTyped(json, false);
  }

  export function GetAdminDashboard200ResponseToJSONTyped(value?: GetAdminDashboard200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalJobs': value['totalJobs'],
        'publishedJobs': value['publishedJobs'],
        'draftJobs': value['draftJobs'],
        'emails': value['emails'],
    };
}

